import axios from "../../axios";

/** @param {{ from: string, to: string }} q */
export function fetchTeacherAttendanceSelfRange(q) {
  return axios.get("/api/v1/teacherAttendance/self/me", {
    params: { from: q.from, to: q.to },
  });
}

export function teacherSelfCheckIn() {
  return axios.post("/api/v1/teacherAttendance/self/checkIn", {});
}

/** @param {{ lateThresholdTodayIso?: string }} [body] */
export function teacherSelfCheckOut(body = {}) {
  return axios.post("/api/v1/teacherAttendance/self/checkOut", body);
}

/** @param {{ teacherId: string, from: string, to: string }} q */
export function fetchTeacherAttendanceReport(q) {
  const { teacherId, from, to } = q;
  return axios.get(`/api/v1/teacherAttendance/report/teacher/${teacherId}`, {
    params: { from, to },
  });
}

/** @param {{ leaveType: string, startDate: string, endDate: string, reason: string }} body */
export function teacherLeaveApply(body) {
  return axios.post("/api/v1/teacherLeave/apply", body);
}

/** @param {{ status?: string, from?: string, to?: string }} [params] */
export function fetchTeacherLeavesSelf(params = {}) {
  return axios.get("/api/v1/teacherLeave/self", { params });
}

/** @param {string} leaveId */
export function teacherLeaveWithdraw(leaveId) {
  return axios.delete(`/api/v1/teacherLeave/${leaveId}/withdraw`);
}

/** @param {{ academicYearSessionId?: string }} [params] */
export function fetchTeacherLeaveBalanceSelf(params = {}) {
  const qs = {};
  if (params.academicYearSession) {
    qs.academicYearSession = params.academicYearSession;
  }
  return axios.get("/api/v1/teacherLeave/balance/self", {
    params: qs,
  });
}

/** @param {{ month?: number, year?: number }} [params] */
export function fetchPayslipsSelf(params = {}) {
  const qs = {};
  if (params.year != null && params.year !== "") qs.year = params.year;
  if (params.month != null && params.month !== "") qs.month = params.month;
  return axios.get("/api/v1/salary/payslips/self", {
    params: qs,
  });
}

/** @param {string} id */
export function fetchPayslipById(id) {
  return axios.get(`/api/v1/salary/payslips/${id}`);
}

/** @param {string} payslipId */
export function fetchPaymentsForPayslip(payslipId) {
  return axios.get(`/api/v1/salary/payments/payslip/${payslipId}`);
}
